import { AuthProvider } from '@ankr.com/auth';

import { shrinkAddress } from 'modules/common/utils/shrinkAddress';
import { shrinkEmail } from 'modules/common/utils/shrinkEmail';

export interface GetAccountNameParams {
  address?: string;
  authProvider?: AuthProvider;
  email?: string;
  isOAuth: boolean;
  nickname?: string;
}

export const getAccountName = ({
  address,
  authProvider,
  email,
  isOAuth,
  nickname,
}: GetAccountNameParams) => {
  const shrinkedAddress = shrinkAddress(address);
  const shrinkedEmail = shrinkEmail(email);
  const shrinkedNickname = shrinkAddress(nickname);

  if (isOAuth) {
    const isGithub = authProvider === AuthProvider.Github;
    const isTelegram = authProvider === AuthProvider.Telegram;
    const shouldUseNickname = isGithub || isTelegram;

    return shouldUseNickname ? shrinkedNickname : shrinkedEmail;
  }

  return shrinkedAddress;
};
